import React from "react";
import { Stack } from "@mui/material";

import { useVendorGetWorkOrders } from "../../hooks";
import { HubTableTemplate } from "../../components";

import { items, keys } from "./helper";

export const OutsideProcessingVendorTable = ({ defaultLocation = 1 }) => {
  const { data, isLoading } = useVendorGetWorkOrders({ defaultLocation });

  const headerProps = { items, includeCheckbox: true };
  const bodyProps = {
    items: data?.rows,
    keys,
  };
  const props = {
    headerProps,
    bodyProps,
    meta: { ...data?.meta },
    isLoading,
  };

  return (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="OutsideProcessingVendorTable" {...props} />
    </Stack>
  );
};

export default OutsideProcessingVendorTable;
